// extracted by mini-css-extract-plugin
var _1 = "styles_backButton__XaD7H";
var _2 = "styles_detailsContainer__nC+Xl";
var _3 = "styles_orderDetails__ypONj";
var _4 = "styles_shipments__Ric3w";
var _5 = "styles_title__cUwYZ";
export { _1 as "backButton", _2 as "detailsContainer", _3 as "orderDetails", _4 as "shipments", _5 as "title" }
